document.addEventListener("readystatechange", (e) => {
  if(document.readyState === "complete") {

    //Check cookie and email popup before running any logic
    const cookie = getCookieValue("noEmailPopup");
    const emailPopup = document.querySelector("#email-popup__emarsys");

    const delay = Number(window.Resources.emailPopup.delay) * 1000;

    if(cookie == null && emailPopup) {

      //Show only after 20 seconds.
      setTimeout(() => {
        showModal(emailPopup);
        emailListeners();
      }, delay);
    }
  }

  function showModal(modal) {

    //Show the email modal
    modal.classList.remove("hidden");

    //Display background overlay
    const body = document.querySelector("body");
          body.classList.add("email__overlay");

    //Set focus and trap
    const closeButton = modal.querySelector(".email-popup__close");
          closeButton.focus();
          
          closeButton.addEventListener("click", hideModal);
          closeButton.addEventListener("keydown", () => {
            if(event.key === "Enter") {
              hideModal();
            }
          });
    
    //Close modal if click anywhere outside
    window.addEventListener("click", (event) => {
      if(modal && !modal.contains(event.target)) {
        hideModal();
      }
    });

    trapFocus(modal);
  }

  function hideModal() {

    const emailPopup = document.querySelector("#email-popup__emarsys");
          emailPopup.classList.add("hidden");

    const body = document.querySelector("body");
          body.classList.remove("email__overlay");

    setCookie();
    removeTrapFocus();
  }

  //Set cookie, user has seen the email popup
  //Expires in X days, set by customizer
  function setCookie() {
    const expirationDays = Number(window.Resources.emailPopup.expiration);

    const date = new Date();
          date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
  
    const expires = "; expires=" + date.toUTCString();
  
    document.cookie = "noEmailPopup" + "=" + encodeURIComponent("yes") + expires + "; path=/; SameSite=Lax";
  }

  //Check if cookie exists function
  function getCookieValue(name) {
    const cookies = document.cookie.split(";");

    for(let i = 0; i < cookies.length; i++) {

      const cookie = cookies[i].trim();

      if(cookie.startsWith(name + "=")) {
        return cookie.substring(name.length + 1);
      }
    }

    return null;
  }
});

//Run validations and listeners for the email form
function emailListeners() {

  //Validation from Emarsys
  function validateEmail(email) {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  }

  function CheckInputs() {
    const emailInput = document.getElementById("inp_3");

    const errorDiv = document.getElementById("emailError");
          errorDiv.innerHTML = "";

    const value = emailInput.value.trim();

    if(!value) {
      errorDiv.innerHTML = "Email: missing data!";
      return false;
    }

    if(!validateEmail(value)) {
      errorDiv.innerHTML = "Email: Wrong input!";
      return false;
    }

    return true;
  }

  const visibleForm = document.getElementById("ProfileForm");
  const iframe = document.getElementById("emarsys-iframe");

  visibleForm.addEventListener("submit", function(e) {

    //Prevent default, so we don't get redirected to emarsys
    e.preventDefault();

    if(!CheckInputs()) return;

    const btn = visibleForm.querySelector("button");
          btn.disabled = true;
          btn.textContent = "Submitting...";

    //Create a fresh form for submission (avoids old handler conflicts)
    const submitForm = document.createElement("form");
          submitForm.action = "https://suite57.emarsys.net/u/register.php";
          submitForm.method = "post";
          submitForm.target = "emarsys-iframe";

    //All the hidden fields Emarsys needs
    const fields = {
      "CID": "1035887773",
      "SID": "",
      "session_id": "",
      "f": "1817",
      "p": "2",
      "a": "r",
      "el": "",
      "endlink": "",
      "llid": "",
      "c": "",
      "counted": "",
      "inp_3255": "en-US",
      "optin": "y",
      "inp_3": document.getElementById("inp_3").value.trim()
    };

    for(const [name, value] of Object.entries(fields)) {
      const input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            input.value = value;

      submitForm.appendChild(input);
    }

    //Append, submit, then clean up
    document.body.appendChild(submitForm);
    submitForm.submit();

    //Remove form shortly after
    setTimeout(() => submitForm.remove(), 1000);
  });

  //Success feedback once the iframe receives the response
  iframe.addEventListener("load", function() {
    const registerArea = document.querySelector(".email-popup__register");

    if(registerArea) {
      registerArea.innerHTML = `
        ${window.Resources.emailPopup.successLineOne != ""
          ? 
          `<p class='email-popup__success'>${window.Resources.emailPopup.successLineOne}</p>`
          : 
            ""
        }
        
        ${window.Resources.emailPopup.successLineTwo != ""
          ? 
          `<p class='email-popup__success'>${window.Resources.emailPopup.successLineTwo}</p>`
          : 
            ""
        }
      `;
    }
  });
}